import {useParams} from "react-router-dom";
import * as React from "react";
import {useCallback, useEffect, useState} from "react";
import {useAppDispatch, withIgnoreErrorCodes} from "store";
import {createEditorTest, fetchEditorElements, fetchEditorTest, fetchEditorTestsEntries, fetchVersions} from "store/editorTest";
import {ContentEditorElementIndexResponse, ContentEditorShowResponse, TestDefinitionCreate} from "generated-api";
import {LinearProgress} from "@mui/material";
import {broadcastNgEditorSuccessEvent, TestEntryType, TestType, VersionsType} from "../../helpers/editorTest";
import {EditorTestForm} from "pages/EditorTest/EditorTestForm";
import {EditorHtmlForm} from "pages/EditorTest/EditorHtmlForm";

export const EditorPage: React.FC<{ type: 'test' | 'html' }> = ({type}) => {
    const {courseId, stepId} = useParams();

    const dispatch = useAppDispatch();
    const [test, setTest] = useState<TestType>();
    const [element, setElement] = useState<ContentEditorElementIndexResponse>();
    const [versions, setVersions] = useState<VersionsType | undefined>(undefined);

    const isCatalogueEnabled = true; // TODO company_space features

    const fetchVersion = useCallback(async () => {
        const versions = (await dispatch(fetchVersions({id: courseId as string})))?.payload as ContentEditorShowResponse;
        setVersions(versions);
    }, [courseId, dispatch]);

    const fetchElements = useCallback(async (stepId: number) => {
        const elements = (await dispatch(fetchEditorElements({stepId})))?.payload as ContentEditorElementIndexResponse[];
        if (elements) {
            const primary = elements.find(item => item.priority === 'primary' && item.element_type === type);
            if (type === 'test' && primary?.id) {
                let test = (await dispatch(fetchEditorTest({
                    elementId: primary.id,
                    initOverrides: withIgnoreErrorCodes({'ActiveRecord::RecordNotFound': null})
                })))?.payload as TestType;
                if (!test?.id) {
                    // 404
                    test = (await dispatch(createEditorTest({
                        body: {
                            element_id: primary.id
                        } as TestDefinitionCreate
                    })))?.payload as TestType;
                    broadcastNgEditorSuccessEvent();
                }
                if (test.id) {
                    test.entries = (await dispatch(fetchEditorTestsEntries({
                        testId: test.id,
                        testId2: test.id
                    })))?.payload as TestEntryType[];
                }
                setTest(test);
            }
            if (type === 'html') {
                setElement(primary)
            }
        }

    }, [type, dispatch]);

    const fetchAll = useCallback(async () => {
        if (stepId) {
            await fetchElements(parseInt(stepId))
        }
        await fetchVersion();

    }, [stepId, fetchElements, fetchVersion])

    useEffect(() => {
        fetchAll().then()

        window.addEventListener("reactVersionDirty", fetchVersion);

        return () => {
            window.removeEventListener("reactVersionDirty", fetchVersion);
        }

        // ignore stepId change as the page will re-mount upon change (angular bridge)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type, fetchAll, fetchVersion]);


    if (!stepId || !versions) {
        return <LinearProgress/>;
    }

    if (type === 'test' && test) {
        return <EditorTestForm stepId={parseInt(stepId)} test={test} versions={versions}
            disabled={versions?.state !== 'draft'} isCatalogueEnabled={isCatalogueEnabled}/>;
    }

    if (type === 'html' && element) {
        return <EditorHtmlForm stepId={parseInt(stepId)} element={element} versions={versions}
            disabled={versions?.state !== 'draft'}/>;
    }

    return null
}
